class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  init() {
    if (typeof Swiper === 'undefined') {
      const start = Date.now();
      const poll = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          this._build();
        } else if (Date.now() - start > 5000) {
          clearInterval(poll);
        }
      }, 50);
      return;
    }
    this._build();
  }

  _build() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 15,
      watchOverflow: true,
      breakpoints: {
        750: { slidesPerView: 2.3, spaceBetween: 15 },
        990: { slidesPerView: 3.3, spaceBetween: 15 },
      },
    });
  }
}

if (!customElements.get('product-gallery-slider')) {
  customElements.define('product-gallery-slider', ProductGallerySlider);
}

(function () {
  function setupNotify(section) {
    var notifyBtn = section.querySelector('[data-notify-trigger]');
    if (!notifyBtn) return;

    var sectionId = section.dataset.section;
    var popup = document.querySelector('[data-notify-popup="' + sectionId + '"]');

    // Helpers ────────────────────────────────────────────────────────

    function showEl(el) {
      if (!el) return;
      el.style.setProperty('display', '', '');
      el.removeAttribute('hidden');
    }
    function hideEl(el) {
      if (!el) return;
      el.style.setProperty('display', 'none', 'important');
    }

    function getSelectedVariant() {
      // Newer Dawn: <script type="application/json" data-selected-variant>{ single variant }</script>
      var script = section.querySelector('script[data-selected-variant]');
      if (!script || !script.textContent.trim()) return null;
      try {
        var data = JSON.parse(script.textContent);
        return data && typeof data.id !== 'undefined' ? data : null;
      } catch (e) { return null; }
    }

    function getVariantsArray() {
      // Older Dawn / other themes: full variants array (NOT the data-selected-variant tag)
      var scripts = section.querySelectorAll(
        'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
      );
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].hasAttribute('data-selected-variant')) continue;
        try {
          var data = JSON.parse(scripts[i].textContent);
          if (Array.isArray(data)) return data;
        } catch (e) {}
      }
      return null;
    }

    function getCurrentVariantId() {
      var input = section.querySelector('input[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    function isSoldOut() {
      // 1) Newer Dawn: selected variant script (most reliable)
      var sv = getSelectedVariant();
      if (sv) return sv.available === false;

      // 2) Older Dawn: variants array + current id
      var list = getVariantsArray();
      var id = getCurrentVariantId();
      if (list && id) {
        var v = list.find(function (x) { return x.id === id; });
        return !v || v.available === false;
      }

      // 3) Last resort: submit button state
      var btn = section.querySelector('.product-form__submit');
      return !!(btn && btn.disabled);
    }

    function update() {
      var submitBtn = section.querySelector('.product-form__submit');
      var soldOut = isSoldOut();

      if (soldOut) {
        hideEl(submitBtn);
        showEl(notifyBtn);
      } else {
        showEl(submitBtn);
        hideEl(notifyBtn);
      }
    }

    // Popup ──────────────────────────────────────────────────────────

    function openPopup() {
      if (!popup) return;
      popup.style.setProperty('display', '', '');
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = popup.querySelector('.notify-popup__input');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }

    function closePopup() {
      if (!popup) return;
      popup.style.setProperty('display', 'none', 'important');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    notifyBtn.addEventListener('click', openPopup);

    if (popup) {
      closePopup(); // ensure hidden on init regardless of CSS

      popup.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-notify-close')) closePopup();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.style.display !== 'none') closePopup();
      });

      var form = popup.querySelector('form');
      var successEl = popup.querySelector('.notify-popup__success');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var sBtn = form.querySelector('button[type="submit"]');
          if (sBtn) { sBtn.textContent = 'Submitting…'; sBtn.disabled = true; }
          fetch('/contact', { method: 'POST', body: new FormData(form) })
            .catch(function () {})
            .then(function () {
              form.style.display = 'none';
              if (successEl) showEl(successEl);
              setTimeout(closePopup, 2500);
            });
        });
      }
    }

    // Reactivity ─────────────────────────────────────────────────────

    section.addEventListener('change', function () {
      setTimeout(update, 120);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        setTimeout(update, 200);
      }
    });

    // Re-run when Dawn replaces the selected-variant script after a variant change
    var sv = section.querySelector('script[data-selected-variant]');
    if (sv && 'MutationObserver' in window) {
      new MutationObserver(function () { update(); })
        .observe(sv, { childList: true, characterData: true, subtree: true });
    }

    // Initial state
    update();
  }

  function init() {
    document.querySelectorAll('product-info[data-section]').forEach(setupNotify);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Visually place the 2nd variant fieldset (Size) after the cart button.
   Keeps the fieldset inside <variant-selects> so Dawn's variant logic stays intact. */
(function () {
  function setupSizeAfterCart(section) {
    const bar = section.querySelector('.product-info-custom__bar');
    const cartDiv = section.querySelector('.product-info-custom__cart');
    const variantSelects = section.querySelector('variant-selects');
    if (!bar || !cartDiv || !variantSelects) return;

    function getSizeFieldset() {
      const fs = variantSelects.querySelectorAll(':scope > fieldset.product-form__input');
      return fs.length >= 2 ? fs[1] : null;
    }

    function place() {
      const sizeFs = getSizeFieldset();
      if (!sizeFs) {
        bar.style.removeProperty('padding-bottom');
        return;
      }

      // Ensure the bar is a positioning context
      if (getComputedStyle(bar).position === 'static') {
        bar.style.position = 'relative';
      }

      // Position absolutely just under the cart button
      sizeFs.style.position = 'absolute';
      sizeFs.style.margin = '0';
      sizeFs.style.zIndex = '1';
      sizeFs.style.top = (cartDiv.offsetTop + cartDiv.offsetHeight + 12) + 'px';
      sizeFs.style.left = '0'; // left-aligned to the bar; change to cartDiv.offsetLeft to align under cart

      // Reserve space at the bottom of the bar so following content isn't overlapped
      bar.style.paddingBottom = (sizeFs.offsetHeight + 24) + 'px';
    }

    // Initial — wait two frames so layout has settled
    requestAnimationFrame(function () { requestAnimationFrame(place); });

    // On resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(place, 100);
    });

    // After Dawn replaces variant-selects content on variant change, re-place
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        requestAnimationFrame(function () { requestAnimationFrame(place); });
      }).observe(variantSelects, { childList: true, subtree: false });
    }
  }

  function init() {
    document.querySelectorAll('product-info[data-section]').forEach(setupSizeAfterCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();